document.addEventListener('DOMContentLoaded', function() {

  let banner = document.getElementById('js-banner'),
      close = banner.querySelector('.js-banner-close');

  if (!sessionStorage.getItem('banner')) {
      banner.classList.add('open');
  }

  close.addEventListener('click', function() {
      sessionStorage.setItem('banner', true);
      banner.classList.remove('open');
  })

});

